import React, { useEffect } from "react";
import { Navigate, Outlet, useNavigate, useParams } from "react-router-dom";
import LandingConnector from "../Landing/Connector/LandingConnector";
import MachineLayout from "../Layout/MachineLayout";
import Page from "../Generic/Page";
import Loader from "../Generic/Loader";
import useMachines from "../util/hooks/useMachines";

/**
 * Validates machine membership and provides MachineLayout. Auth is enforced by AuthenticatedRoute.
 */
const MachineRoute = (props) => {
	const { machineId } = useParams();
	const navigate = useNavigate();
	const { machines, loaded, error } = useMachines();

	useEffect(() => {
		if (!loaded) {
			return;
		}
		const machineData = machines.find((item) => item._id === machineId);
		if (!machineData) {
			navigate("/404", { replace: true });
			return;
		}
		props.setMachineID(machineData);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [machineId, loaded, machines]);

	if (props.machineID !== "") {
		return (
			<MachineLayout>
				<Outlet />
			</MachineLayout>
		);
	}

	if (error) {
		return <Navigate to={"/404"} replace />;
	}

	return (
		<Page>
			<Loader />
		</Page>
	);
};

export default LandingConnector(MachineRoute);
